import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';

class Expired extends Component {

    render() {
        return(
          <div className="middle-box text-center loginscreen animated fadeInDown">
                  <div>
                      <div>
                          <h1 className="logo-name">ERROR</h1>
                      </div>
                      <h3>LICENSE EXPIRED</h3>
                      <p>Please verify your license credentials</p>
                      <p className="m-t"> <small>Call Main Project Support</small> </p>
                  </div>
              </div>

            );
    }
};

export default Expired;



// WEBPACK FOOTER //
// ./src/Expired.js